module.exports = __webpack_public_path__ + "static/media/birthday.95edf15d.jpg";